import { useState, useEffect } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { getCurrencyOfCountry } from "../../../utils/utils";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

export const CashbackOffer = ({
  cashback,
  isListPage = false,
  isSmall = false,
}) => {
  const {
    amount,
    percentage,
    cashback_type,
    expiry_date,
    country,
    max_cashback,
    min_order_amount,
    cashback_segment,
    cashback_slabs_attributes = [],
  } = cashback;

  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!expiry_date) return;

    const interval = setInterval(() => {
      const now = moment();
      const expiry = moment(expiry_date);
      const diff = moment.duration(expiry.diff(now));

      if (diff.asMilliseconds() <= 0) {
        setTimeLeft("");
        clearInterval(interval);
      } else {
        let timeString = [];

        if (diff.days() > 0) timeString.push(`${diff.days()}d`);
        if (diff.hours() > 0 || diff.days() > 0)
          timeString.push(`${diff.hours()}h`);
        if (diff.minutes() > 0 || diff.hours() > 0 || diff.days() > 0)
          timeString.push(`${diff.minutes()}m`);
        timeString.push(`${diff.seconds()}s left`);

        setTimeLeft(timeString.join(" : "));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiry_date]);

  return cashback_segment === "order_type" ? (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <a
        onClick={(e) => setShowPopup(true)}
        style={{
          textDecoration: "underline",
          fontSize: "13px",
          color: "#003366",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        {t("cashback.view-cashback")}
      </a>

      {showPopup && (
        <Modal
          centered
          size="sm"
          show={showPopup}
          closeModal={() => {
            showPopup(false);
          }}
          className={isSmall ? "service-modal-mobile" : "service-modal"}
        >
          <Modal.Header
            style={{
              justifyContent: "center",
              paddingBottom: "0px",
            }}
          >
            <Modal.Title>
              <h5
                style={{
                  fontSize: "24px",
                  padding: "0 1rem 1rem",
                  margin: "0",
                  fontWeight: 700,
                  color: "#003366",
                }}
              >
                {t("cashback.available-cashbacks")}
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              padding: "15px",
              borderRadius: "8px",
            }}
          >
            {cashback_slabs_attributes.map((slab, i) => (
              <div
                key={i}
                style={{
                  padding: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  {parseFloat(slab.max_amount)
                    ? t("cashback.orders-between", {
                        min: parseFloat(slab.min_amount).toLocaleString(),
                        max: parseFloat(slab.max_amount).toLocaleString(),
                        currency: getCurrencyOfCountry(country),
                        cashback: parseFloat(
                          slab.cashback_amount
                        ).toLocaleString(),
                      })
                    : t("cashback.orders-above-format", {
                        amount: parseFloat(slab.min_amount).toLocaleString(),
                        cashback: parseFloat(
                          slab.cashback_amount
                        ).toLocaleString(),
                        currency: getCurrencyOfCountry(country),
                      })}
                </span>
              </div>
            ))}
            <p className="m-0 pl-2">
              <span
                style={{ lineHeight: 1, fontWeight: 700, color: "#003366" }}
              >
                {t("cashback.expires-in", { time: timeLeft })}
              </span>
            </p>
            <div style={{ float: "right" }}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowPopup(false);
                }}
                style={{
                  marginTop: "12px",
                  padding: "6px 12px",
                  backgroundColor: "#003366",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                }}
              >
                {t("common.close")}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  ) : (
    <div>
      <p className="font-bold m-0">
        <span style={{ lineHeight: 1, fontWeight: 700, color: "#003366" }}>
          {cashback_type === "amount"
            ? t("cashback.get-cashback-amount-minimum-order", {
                amount:
                  getCurrencyOfCountry(country) + " " + parseFloat(amount),
                minimumAmount:
                  getCurrencyOfCountry(country) +
                  " " +
                  parseFloat(min_order_amount),
              })
            : t("cashback.get-cashback-amount", {
                percentage: parseFloat(percentage) + "%",
                maxAmount:
                  getCurrencyOfCountry(country) +
                  " " +
                  parseFloat(max_cashback),
                minimumAmount:
                  getCurrencyOfCountry(country) +
                  " " +
                  parseFloat(min_order_amount),
              })}
        </span>
      </p>
      <p className="m-0">
        <span style={{ lineHeight: 1, fontWeight: 700, color: "#003366" }}>
          {!isListPage && t("cashback.expires-in", { time: timeLeft })}
        </span>
      </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  country: state.language.country,
});

export default connect(mapStateToProps, null)(CashbackOffer);
